import React, {useState, useEffect, useRef} from 'react';
import axios from 'axios';
import '../config.js';

import { alertService } from '../services/alert.service.js';
import Progress from '../components/progress.js';
import ImageListItem from '../components/imageListItem.js';
import { Paginator } from '../components/paginator.js';

function ImagePicker(props){
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState('');
  const [filteredImages, setFilteredImages] = useState(props.item.images);
  const [offset, setOffset] = useState(0);
  const [ranking, setRanking] = useState(1);
  const [images, setImages] = useState(props.item.images);
  const [file, setFile] = useState(null);
  const [label, setLabel] = useState('');

  let searchForm = useRef();

  const handleSearch = (event) => {
    const target = event.target;
    const value = target.value;
    const filtered = [];
    for(let i = 0;i<images.length;i++){
      if(value === undefined || value.trim() === '' || images[i].label.indexOf(value) >= 0){
        filtered.push(images[i]);
      }
    }
    setFilteredImages(filtered);
  }

  const handleSubmit = (event) =>{
    event.preventDefault();
    if(label && file){
      const formData = new FormData;
      formData.append('file', file);
      formData.append('file_name', file.name);
      formData.append('label', label);
      formData.append('ranking', ranking);
      formData.append('task', "upload");
      formData.append('type', props.type);
      formData.append('item', props.id);
      formData.append('token', localStorage.getItem("token"));
      setLoading(true);
      axios.post(global.config.api_server+'document',formData).then(res => {
        if(res.status === 200 && res.data.status === "success"){
          alertService.success('Image uploaded');
          setTimeout(function(){
            window.location.reload();
          }, 1000);
        }else{
          alertService.error(res.data.error);
          setLoading(false);
        }
      }).catch(err => {
        alertService.error(err);
        setLoading(false);
      });
    }else{
      alertService.error('All the fields are required');
      setLoading(false);
    }
  }

  const resetSearch = (event) => {
    searchForm.current.reset();
    setSearch('');
    setFilteredImages(images);
  }

  const onPageChange = (index_start) => {
    setOffset(index_start);
  }  

  let uploadDocument = "";
  if(parseInt(localStorage.getItem("role")) >= 3){
    uploadDocument = <a href="#" className={'btn btn-icon-split float-right btn-primary'} data-toggle="modal" data-target="#createDocumentModal">
                  <span className="icon text-white-50">
                    <i className="fas fa-image"></i>
                  </span>
                  <span className="text">Upload new image</span>
                </a>;
  }
  let total = 0;
  let counter = 0;
  let offsetCounter = 0;
  const paginated_images = [];
  for (const u of filteredImages) {
    total++;
    offsetCounter++;
    if (offsetCounter > offset && counter < global.config.items_per_page){
      counter++;
      paginated_images.push(u);
    }
  }
  return(
    <div>
      <div className="card shadow mb-4">
        <div className="card-header py-3">
          {uploadDocument}
          <form ref={searchForm} className="form-inline">
              <h6 className={'form-group mr-3 font-weight-bold text-primary'}>Image(s)</h6>
              <div className="form-group mr-3">
                <input type="search" label="search" className="form-control" placeholder="Search" onChange={handleSearch}/>
              </div>
              {search &&
              <div className="form-group mr-3">
                <a href="#" className="btn btn-default btn-icon-split" onClick={resetSearch}>
                  <span className="icon">
                    <i className="fas fa-times"></i>
                  </span>
                </a>
              </div>
              }
            </form>
        </div>
        <div className="card-body">
          <div className="table-responsive">
            <div className="row">
            {loading === true ? (
              <Progress label='Loading..' small={true}/>
            ):null}
              <div className="col-sm-12">
                <table className="table table-bordered" width="100%">
                  <thead>
                    <tr>
                      <th>Showcase</th>
                      <th>Label</th>
                      <th>Ranking</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paginated_images.map(doc =>
                      <ImageListItem info={doc} key={doc.document_id}/>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            <Paginator
                itemCount={total}
                itemsPerPage={global.config.items_per_page}
                showNextPages={2}
                showPrevPages={2}
                filterTotal={filteredImages.length}
                grandTotal={images.length}
                onClick={onPageChange.bind(this)}
              />
          </div>
        </div>
      </div>
      <div className="modal fade" id="createDocumentModal" tabIndex="-1" role="dialog" aria-labelledby="create-popup" aria-hidden="true">
        <div className="modal-dialog modal-xl" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="create-popup">Upload new image</h5>
              <button className="close" type="button" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
            </div>
            {(props.limit === 0 || (props.limit > 0 && props.limit > images.length))?
            <form>
              <div className="modal-body">
                <div className="form-group">
                  <label>Label</label>
                  <input type="text" value={label} maxLength="50" name="label" className="form-control" id="label" placeholder="Enter Label" onChange={(e) => setLabel(e.target.value)}/>
                </div>
                <div className="form-group">
                  <label>File</label>
                  <input type="file" maxLength="50" name="file" className="form-control" id="file" placeholder="Upload File" onChange={(e) => setFile(e.target.files[0])}/>
                </div>
                <div className="form-group">
                  <label>Ranking (Highest ranking will show on top)</label>
                  <input type="number" max="100" name="ranking" value={ranking} className="form-control" id="ranking" onChange={(e) => setRanking(e.target.value)}/>
                </div>
                {loading === true ? (
                  <Progress label='Uploading..' small={true}/>
                ):null}
              </div>
              <div className="modal-footer">
                <button className="btn btn-default" type="reset" data-dismiss="modal">Close</button>
                <button className={'btn btn-primary'} type="button" onClick={handleSubmit}>Submit</button>
              </div>
            </form>
            :<p>Only {props.limit} image(s) allowed for this item.</p>}
          </div>
        </div>
      </div>
    </div>
  )
}

export default ImagePicker;